import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { IIndustry } from 'models/industry';
import { useTranslation } from 'react-i18next';
import { IVendor } from 'models/vendor';


interface Props {
  open: boolean;
  loading: boolean;
  vendors: IVendor[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const AddCorporateVendor: React.FC<Props> = ({ open, loading, vendors, onClose, onSubmit, onChanges }) => {
  const {t} = useTranslation()
  let industriesOptions = vendors.map((industry) => {
    return { value: industry.id, label: industry.name };
  });
  let basicFields: IFormField[] = [
    {
      name: 'vendorId',
      label: t('T_vendors'),
      type: InputTypes.SELECT,
      placeholder: t('T_vendors'),
      options: industriesOptions,
      multiple: false,
      internalLabel: true,
      required: true
    },
    {
      name: 'active',
      label: t('T_active'),
      type: InputTypes.CHECKBOX,
      internalLabel: true
    },
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_vendor')}
      maxWidth="lg"
      children={<Grid container p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Grid>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
        {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddCorporateVendor;